import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import Text from '../../../../../v2BaseComponents/Text';
import PromptButton from '../../../../../shared/PromptButton';
import { useIsMobileLayout } from '../../../../../../hooks/useIsMobileLayout';
import useRecordEvent from '../../../../../../hooks/useRecordEvent';

const intl = getIntl('DeleteChatButton', {
    deleteChat: 'Delete',
    mobileDeleteChat: 'Delete',
    deleteChatPromptMessage: 'Are you sure you want to delete this chat?  This cannot be undone.',
    deleteChatPromptConfirmButtonText: 'Delete',
    deleteChatPromptCancelButtonText: 'Cancel',
});

export type DeleteChatButtonOwnProps = {
    onDelete: () => void;
    isDeleting: boolean;
    isDisabled: boolean;
};

export type DeleteChatButtonProps = DeleteChatButtonOwnProps;

const DeleteChatButton: React.FC<DeleteChatButtonProps> = (props) => {
    const isMobile = useIsMobileLayout();
    const record = useRecordEvent();

    return (
        <PromptButton
            buttonProps={{
                isDisabled: props.isDeleting || props.isDisabled,
                leftIcon: 'Trash2',
                variant: 'ghost',
                title: intl(isMobile ? 'mobileDeleteChat' : 'deleteChat'),
                testID: 'delete-chat-button',
            }}
            promptTitle={intl('deleteChat')}
            actions={(onClose) => [
                {
                    onPress: () => {
                        props.onDelete();
                        record('deleteChat');
                        onClose();
                    },
                    title: intl('deleteChatPromptConfirmButtonText'),
                    variant: 'alert',
                    isDisabled: props.isDeleting,
                    testID: 'delete-chat-confirm-button',
                },
                {
                    onPress: onClose,
                    title: intl('deleteChatPromptCancelButtonText'),
                    variant: 'secondary',
                },
            ]}
            renderPromptContents={() => <Text variant="body-1">{intl('deleteChatPromptMessage')}</Text>}
        />
    );
};

export default React.memo(DeleteChatButton);
